import type { QuestionProps } from "../../../../../../components/Questionnaire/Section/Question/types";
import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type { Answers } from "../../../../types";
import type { FlattenGroupResult } from "../types";

/**
 * Gets the primary answer from either the question's answer property or the answers map.
 * Returns null if no answer is found or if the answer is not a string.
 */
export const getPrimaryAnswer = (
  primaryQuestion: QuestionProps,
  answers: Answers,
): string | null => {
  const answer = primaryQuestion.answer || answers[primaryQuestion.name];
  return typeof answer === "string" ? answer : null;
};

/**
 * Creates an empty flatten group result, preserving existing answers and visibility.
 * Used when group validation fails or all questions are hidden.
 */
export const createEmptyFlattenResult = (
  answers: Answers,
  visibility: VisibilityMap,
): FlattenGroupResult => ({
  questions: [],
  answers,
  visibility,
  groups: {},
});
